<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약재입고 상세정보</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>제품입고코드</span></th>
                  <td>{{medWrhsInfo.med_wrhs_cd}}</td>
                </tr>
                <tr>
                  <th><span>약재명</span></th>
                  <td>{{medWrhsInfo.med_hrb_nm}}</td>
                </tr>
                <tr>
                  <th><span>원산지</span></th>
                  <td v-if="showOrgReg == true">
                    <div class="form_inline">
                      <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="medWrhsInfo.org_plce_nm">
                      <button class="btn btn_md btn_deepblue" v-b-modal.orgPlaceSearch>검색</button>
                      <button class="btn btn_md btn_darkblue" @click="fn_org_save">저장</button>
                    </div>
                  </td>
                  <td v-else>{{medWrhsInfo.org_plce_nm}}</td>
                  
                </tr>
                <tr>
                  <th>약재 입고일자</th>
                  <td>{{medWrhsInfo.wrhs_dt}}</td>
                </tr>
                <tr>
                  <th>약재 규격유형</th>
                  <td>{{medWrhsInfo.standard_type_nm}}</td>
                </tr>
                <tr>
                  <th>제약회사</th>
                  <td>{{medWrhsInfo.companyNm}}</td>
                </tr>
                <tr>
                  <th>제품코드</th>
                  <td>{{medWrhsInfo.product_cd}}</td>
                </tr>
                <tr>
                  <th><span>약재 입고량(g)</span></th>
                  <td>{{medWrhsInfo.wrhs_qnty}}g</td>
                </tr>
                <tr>
                  <th><span>약재 입고단가</span></th>
                  <td>{{medWrhsInfo.wrhs_price}}원</td>
                </tr>
                <tr>
                  <th><span>건보단가(g당)</span></th>
                  <td>{{medWrhsInfo.gunbo_price}}원</td>
                </tr>
                <tr>
                  <th><span>일반단가(g당)</span></th>
                  <td>{{medWrhsInfo.stand_price}}원</td>
                </tr>
                <tr>
                  <th>유통기한</th>
                  <td>{{medWrhsInfo.expr_dt}}</td>
                </tr>
                <tr>
                  <th>사용량</th>
                  <td>{{medWrhsInfo.use_qnty}} g</td>
                </tr>                
                <tr>
                  <th>사용완료여부</th>
                  <td>{{medWrhsInfo.use_cmpt_yn}}</td>
                </tr>                
                <tr>
                  <th>폐기처리여부</th>
                  <td>{{medWrhsInfo.use_dpsl_yn}}</td>
                </tr>                
                <tr>
                  <th>폐기수량</th>
                  <td>{{medWrhsInfo.use_dpsl_qnty}} g</td>
                </tr>                
                <tr>
                  <th>비고</th>
                  <td>없음</td>
                </tr>                
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_list_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_gray" @click="fn_del_med(medWrhsInfo.med_wrhs_cd)">삭제</button>
                <button v-if="medWrhsInfo.use_qnty == '0'" class="btn btn_md btn_darkblue"  @click="fn_mod_med(medWrhsInfo.med_wrhs_cd)">수정</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <SearchOrgPlaceModal 
        :title="'원산지 검색'" 
        :searchName="'원산지'"
        :searchData="medWrhsInfo.orgPlcNm"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_orgPlace_callback"
      />
    </div>
</template>

<script>

  import axios from 'axios'
  import SearchOrgPlaceModal from "@/modal/common/orgPlaceSearch.vue" 

  export default {
    name: 'MedicineWrhsMngtDtl',
    components: {
      SearchOrgPlaceModal
    },
    data() {
      return {
        medWrhsCd : '',
        medWrhsInfo : {},
        showOrgReg : false
      }
    },
    created(){
            this.medWrhsCd = this.$store.getters['medWrhs/getMedWhrsCd']
            console.log("@@@@ mediWrhsCd : "+this.mediWrhsCd);

            this.fn_search(this.medWrhsCd);
    },
    methods : {
        fn_search(medWrhsCd){

            let param = new Object();
            param.medWrhsCd = medWrhsCd;

            console.log("@@@@ param : %o",param);

            axios
                .post("/api/medicineWrhs/medicineWrhsDetail", param)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.medWrhsInfo = res.data.medWrhsInfo;

                    if(this.medWrhsInfo.org_plce_nm == '' && this.medWrhsInfo.use_qnty != '0'){
                      this.showOrgReg = true;
                    }

                    console.log("@@@@ medWrhsInfo : %o",this.medWrhsInfo);
                })
                .catch((err) => console.log(err));
                
        },
        fn_move_list_page(){
            this.$store.dispatch('medWrhs/setStatus', ''); 
            this.$router.push("/admin/medicine/MedicineWrhsMngt");
        },
        fn_del_med(medWrhsCd){
            let param = new Object();
            param.medWrhsCd = medWrhsCd;
            if (confirm("정말 삭제하시겠습니까?")) {

            axios
                .post("/api/medicineWrhs/deleteMedicineWrhs", param)
                .then((res) => {
                    alert("삭제되었습니다");
                    this.fn_move_page();                        
                })
                .catch((err) => console.log(err));
            }
        },
        fn_mod_med(code){
            this.$store.dispatch('medWrhs/setMedWhrsCd', code);
            this.$store.dispatch('medWrhs/setStatus', 'M'); 

            this.$router.push("/admin/medicine/MedicineWrhsMngtReg");
        }, 
        fn_move_page(){
            this.$store.dispatch('medWrhs/setMedicineMngtinit'); 

            this.$router.push("/admin/medicine/MedicineWrhsMngt");
        },
        fn_orgPlace_callback(orgPlceObj){

        console.log("### orgPlceObj : %o",orgPlceObj);

        //원산지 정보 콜백정보
        this.medWrhsInfo.org_plce_cd = orgPlceObj.org_plce_cd;
				this.medWrhsInfo.org_plce_nm = orgPlceObj.org_plce_nm;

      },
      fn_org_save(){
        if(this.medWrhsInfo.org_plce_cd == ''){
          alert("원산지를 입력해주세요.");
        }

        axios
          .post("/api/medicineWrhs/updateOrgInfo", this.medWrhsInfo)
          .then((res) => {
              alert("원산지가 저장되었습니다.");
              this.showOrgReg = false;
              this.fn_search(this.medWrhsCd);                     
          })
          .catch((err) => console.log(err));

      }           
    }
  }
</script>